// src/errors/NotFound.tsx

import ErrorPage from "./ErrorPage";

export default function NotFound() {
    return (
        <ErrorPage
            variant="not-found"
            statusLabel="Navigation status"
            statusCode={404}
            title="Page Not Found"
            message="The page you are looking for doesn't exist or has been moved."
            actionLabel="Go to Dashboard"
            redirectTo="/"
            secondaryActionLabel="Go Back"
            secondaryActionType="back"
            helperText="The link may be outdated, or you may no longer have access to this location."
        />
    );
}